import React, {
  Suspense,
  createContext,
  lazy,
  useEffect,
  useState,
} from "react";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router";

import {
  DgaToaster,
} from "./components/Common/DgaNotification/DgaNotification";

import GuestLayout from "./layouts/GuestLayout";
import AuthLayout from "./layouts/AuthLayout";
import ProtectedRoute from "./ProtectedRoute";

import PageLoader from "./components/Common/PageLoader/PageLoader";
import { Toaster } from "react-hot-toast";

const CustomerRegistration = lazy(() =>
  import("./pages/Customer")
);

const EditProfile = lazy(() =>
  import("./pages/Customer/editProfile")
);

const Login = lazy(() =>
  import("./pages/Login")
);

const CustomerDashboard = lazy(() =>
  import("./pages/Customer/dashboard")
);


const BusinessDashboard = lazy(() =>
  import("./pages/Business/dashBoard")
);

const BusinessRegisteration = lazy(() =>
  import("./pages/Business")
);

const EditProfileBusiness = lazy(() =>
  import("./pages/Business/editProfileBusiness")
);

const ChangePasswordBusiness = lazy(() =>
  import("./pages/Business/changePasswordBusiness")
);

const CreateSubsidy = lazy(() =>
  import("./pages/Business/Subsidy/createSubsidy")
);

const AddSubsidyJob = lazy(() =>
  import("./pages/Business/Subsidy/addSubsidyJob")
);

const SubsidyJobList = lazy(() =>
  import("./pages/Business/Subsidy/subsidyJobsList")
);

const ContractList = lazy(() =>
  import("./pages/Business/Subsidy/contractList")
);

const LinkCustomer = lazy(() =>
  import("./pages/Business/Subsidy/linkCustomer")
);

const RemoveCustomer = lazy(() =>
  import("./pages/Business/Subsidy/removeCustomer")
);

const AddAttendance = lazy(() =>
  import("./pages/Business/Subsidy/addAttendance")
);

const AddInvoice = lazy(() =>
  import("./pages/Business/Subsidy/addInvoice")
);

const InvoiceList = lazy(() =>
  import("./pages/Business/Subsidy/invoiceList")
);

const ViewInvoice = lazy(() =>
  import("./pages/Business/Subsidy/viewInvoiceDetail")
);

const EmployeList = lazy(() =>
  import("./pages/Business/Subsidy/employeList")
);

const PrintContract = lazy(() =>
  import("./pages/Business/Subsidy/printContract")
);

const ServiceStop = lazy(() =>
  import("./pages/Internal/ServiceControl")
);

const ChangePasswordFirst = lazy(() =>
  import("./pages/Business/change-passwordfirst")
);

const InternalDashboard = lazy(() =>
  import("./pages/Internal/dashBoard")
);

const ViewSubsidy = lazy(() =>
  import("./pages/Internal/subsidy/viewSubsidy")
);

const SubsidyJobListSystem = lazy(() =>
  import("./pages/Internal/subsidy/subsidyJobsList")
);

const AddSubsidyJobSystem = lazy(() =>
  import("./pages/Internal/subsidy/addSubsidyJob")
);

const MyactivityList = lazy(() =>
  import("./pages/Internal/myactivity/myactivityList")
);

const ViewActivity = lazy(() =>
  import("./pages/Internal/myactivity/viewActivity")
);

const ViewBusinessPartner = lazy(() =>
  import("./pages/Internal/subsidy/viewBusinesspartner")
);

const BusinessProfileSystem = lazy(() =>
  import("./pages/Internal/subsidy/businessProfileSystem")
);

const ViewCustomers = lazy(() =>
  import("./pages/Internal/subsidy/viewCustomers")
);

const CustomerDetail = lazy(() =>
  import("./pages/Internal/subsidy/viewCustomerDetail")
);

const ViewInvoices = lazy(() =>
  import("./pages/Internal/subsidy/viewInvoices")
);

const SystemInvoiceDetail = lazy(() =>
  import("./pages/Internal/subsidy/systemInvoices")
);

const ApproveMatch = lazy(() =>
  import("./pages/Internal/subsidy/approveMatch")
);

const PrintContractActive = lazy(() =>
  import("./pages/Internal/subsidy/printContractActive")
);

const ComprehensiveContract = lazy(() =>
  import("./pages/Internal/subsidy/comprehensive")
);

const AddComContract = lazy(() =>
  import("./pages/Internal/subsidy/addCom")
);

const ViewUsers = lazy(() =>
  import("./pages/Internal/subsidy/viewUsers")
);

const WorkFlowList = lazy(() =>
  import("./pages/Internal/subsidy/workflowList")
);

const PrintCom = lazy(() =>
  import("./pages/Internal/printCom")
);

const NewActiveContractPrint = lazy(() =>
  import("./pages/Internal/subsidy/newActiveContractPrint")
);

const PrintContractDetails = lazy(() =>
  import("./pages/Internal/subsidy/printContractDetails")
);

const SearchPc = lazy(() =>
  import("./pages/Internal/subsidy/searchPc")
);

const PaymentBpReport = lazy(() =>
  import("./pages/Internal/subsidy/paymentBpReport")
);

const PaymentPcReport = lazy(() =>
  import("./pages/Internal/subsidy/paymentPc")
);

const PrintInvoiceSummary = lazy(() =>
  import("./pages/Internal/subsidy/printInvoiceSummary")
);

const ChangePasswordSystem = lazy(() =>
  import("./pages/Internal/change-passwordsystem")
);

const OtpScreen = lazy(() =>
  import("./pages/Login/otp")
);

const RegistrationSuccess = lazy(() =>
  import("./pages/Registration/RegistrationSuccess")
);

const MyContext = createContext();

 <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
        }}
  />

const App = () => {
  const [
    isToggleSidebar,
    setIsToggleSidebar,
  ] = useState(false);

  const [
    isLogin,
    setIsLogin,
  ] = useState(true);

  const [
    isHideSidebarAndHeader,
    setisHideSidebarAndHeader,
  ] = useState(false);

  const [
    windowWidth,
    setWindowWidth,
  ] = useState(window.innerWidth);

  const [
    isOpenNav,
    setIsOpenNav,
  ] = useState(false);

  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "light"
  );

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
      localStorage.setItem("theme", "dark");
      return;
    }

    document.body.classList.add("light");
    document.body.classList.remove("dark");
    localStorage.setItem("theme", "light");
  }, [theme]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  const openNav = () => {
    setIsOpenNav(true);
  };

  const values = {
    isToggleSidebar,
    setIsToggleSidebar,
    isLogin,
    setIsLogin,
    isHideSidebarAndHeader,
    setisHideSidebarAndHeader,
    theme,
    setTheme,
    windowWidth,
    openNav,
    isOpenNav,
    setIsOpenNav,
  };

  return (
    <BrowserRouter>
      <MyContext.Provider value={values}>
        <DgaToaster />

        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<GuestLayout />}>
              <Route
                path="/customer/register"
                element={<CustomerRegistration />}
              />

              <Route
                path="/business/register"
                element={<BusinessRegisteration />}
              />

              <Route
                path="/registration/success"
                element={<RegistrationSuccess />}
              />

              <Route
                path="/business/change-passwordfirst"
                element={<ChangePasswordFirst />}
              />

              <Route
                path="/system/change-passwordsystem"
                element={<ChangePasswordSystem />}
              />

              

              <Route
                path="/system/printCom"
                element={<PrintCom />}
              />

              <Route
                path="/"
                element={<Login />}
              />

              <Route
                path="/login"
                element={<Login />}
              />

              <Route
                path="/otp"
                element={<OtpScreen />}
              />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={["Customer"]}
                />
              }
            >
              <Route element={<AuthLayout />}>
                <Route
                  path="/customer/dashboard"
                  element={<CustomerDashboard />}
                />

                <Route
                  path="/customer/editProfile"
                  element={<EditProfile />}
                />

                
              </Route>
            </Route>

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={["Internal"]}
                />
              }
            >
              <Route element={<AuthLayout />}>
                <Route
                  path="/system/dashboard"
                  element={<InternalDashboard />}
                />

                <Route
                  path="/system/subsidy/viewSubsidy"
                  element={<ViewSubsidy />}
                />

                <Route
                  path="/system/subsidy/jobList"
                  element={<SubsidyJobListSystem />}
                />

                <Route
                  path="/system/subsidy/addJob"
                  element={<AddSubsidyJobSystem />}
                />

                <Route
                  path="/system/business/viewbusinesspartner"
                  element={<ViewBusinessPartner />}
                />

                <Route
                  path="/system/business/viewBusiness"
                  element={<BusinessProfileSystem />}
                />

                <Route
                  path="/system/customer/viewCustomers"
                  element={<ViewCustomers />}
                />

                <Route
                  path="/system/customer/customerDetail"
                  element={<CustomerDetail />}
                />

                <Route
                  path="/system/invoice/viewInvoices"
                  element={<ViewInvoices />}
                />

                <Route
                  path="/system/invoice/viewInvoiceDetailSystem"
                  element={<SystemInvoiceDetail />}
                />

                <Route
                  path="/system/match/approveMatch"
                  element={<ApproveMatch />}
                />

                <Route
                  path="/system/contract/printContractActive"
                  element={<PrintContractActive />}
                />

                <Route
                  path="/system/serviceControl"
                  element={<ServiceStop />}
                />

                <Route
                  path="/system/contract/newActiveContractPrint/:contractId"
                  element={<NewActiveContractPrint />}
                />

                <Route
                  path="/system/contract/printMalaf/:contractId"
                  element={<PrintContractDetails />}
                />

                <Route
                  path="/system/contract/invoiceSummary/:invoiceId/:activityId"
                  element={<PrintInvoiceSummary />}
                />

                <Route
                  path="/system/contract/comprehensive"
                  element={<ComprehensiveContract />}
                />

                <Route
                  path="/system/contract/addComcontract"
                  element={<AddComContract />}
                />

                <Route
                  path="/system/myactivity/myactivityList/:processId"
                  element={<MyactivityList />}
                />

                <Route
                  path="/system/myactivity/viewActivity/:activityId"
                  element={<ViewActivity />}
                />

                <Route
                  path="/system/accesscontrol/changepassword"
                  element={<ViewUsers />}
                />

                <Route
                  path="/system/workflow/workflowList"
                  element={<WorkFlowList />}
                />

                <Route
                  path="/system/customer/searchPc"
                  element={<SearchPc />}
                />

                <Route
                  path="/system/reports/paymentBp"
                  element={<PaymentBpReport />}
                />

                <Route
                  path="/system/reports/paymentPc"
                  element={<PaymentPcReport />}
                />
              </Route>
            </Route>

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={["Business"]}
                />
              }
            >
              <Route element={<AuthLayout />}>
                <Route
                  path="/business/dashboard"
                  element={<BusinessDashboard />}
                />

                <Route
                  path="/business/editProfileBusiness"
                  element={<EditProfileBusiness />}
                />

                <Route
                  path="/business/changePasswordBusiness"
                  element={<ChangePasswordBusiness />}
                />

                <Route
                  path="/business/subsidy/createSubsidy"
                  element={<CreateSubsidy />}
                />

                <Route
                  path="/business/subsidy/printContract"
                  element={<PrintContract />}
                />

                <Route
                  path="/business/subsidy/addJob"
                  element={<AddSubsidyJob />}
                />

                <Route
                  path="/business/subsidy/joblist"
                  element={<SubsidyJobList />}
                />

                <Route
                  path="/business/subsidy/contractlist"
                  element={<ContractList />}
                />

                <Route
                  path="/business/subsidy/linkcustomer"
                  element={<LinkCustomer />}
                />

                <Route
                  path="/business/subsidy/removecustomer"
                  element={<RemoveCustomer />}
                />

                <Route
                  path="/business/subsidy/addattendance"
                  element={<AddAttendance />}
                />

                <Route
                  path="/business/invoice/addinvoice"
                  element={<AddInvoice />}
                />

                <Route
                  path="/business/invoice/invoicelist"
                  element={<InvoiceList />}
                />

                <Route
                  path="/business/invoice/viewInvoiceDetail"
                  element={<ViewInvoice />}
                />

                <Route
                  path="/business/subsidy/totalemployes"
                  element={<EmployeList />}
                />
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </MyContext.Provider>
    </BrowserRouter>
  );
};

export default App;
export { MyContext };